<template>
    <div>
        <div v-if="$t('FOOTER') !== ''" id="footer" class="unselectable">
            {{ $t('FOOTER') }}
        </div>

        <div v-if="$store.showLoadingOverlay" class="cic-overlay-invisible"></div>

        <Navigate
            v-if="$store.requestParams"
            :navigate-options="$store.navigateOptions"
            :export-options="$store.exportOptions"
        />
    </div>
</template>

<script>
    import Navigate from '@/components/Navigate';

    export default {
        name: 'AppFooter',
        components: {
            Navigate,
        },
    };
</script>
